import React from "react";
import ReactDOM from "react-dom/client";
import './assets/Css/all.css';
import App from "./App";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./Auth/AuthConfig";
import { MsalProvider } from "@azure/msal-react";
import {
    progressBarFetch,
    setOriginalFetch,
    ProgressBar,
} from "./Components/progressbar/progressbar";

import { registerLicense } from '@syncfusion/ej2-base';

import './i18n';

// Registering Syncfusion license key
registerLicense('Ngo9BigBOggjHTQxAR8/V1NBaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXledXRRRGJfUEdyXEQ=');

const msalInstance = new PublicClientApplication(msalConfig);

// for progressbar
setOriginalFetch(window.fetch);
window.fetch = progressBarFetch;

const root = ReactDOM.createRoot(
    document.getElementById('root')
);

root.render(
    <MsalProvider instance={msalInstance}>
        <ProgressBar style={{ marginBottom: "10px" }} />
        <App />
    </MsalProvider>
);
